import { UtilsService } from "@/services/utils/utils.service";
import { authorizedAPI, unauthorizedAPI } from "@/config/axios.config";
import type { CompanyInvitation } from "@/types/user.types";

const utils = new UtilsService();

export interface CreateInvitationDto {
  emails: string[];
}

export interface InvitationValidationResponse {
  company: {
    id: string;
    name: string;
  };
  inviter: {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
  };
}

class InvitationService {
  createInvitations(data: CreateInvitationDto) {
    return utils.handleApiRequest(() =>
      authorizedAPI.post<CompanyInvitation[]>("/invitation", data)
    );
  }

  getInvitations() {
    return utils.handleApiRequest(() =>
      authorizedAPI.get<CompanyInvitation[]>("/invitation")
    );
  }

  validateInvitation(token: string): Promise<InvitationValidationResponse> {
    return utils.handleApiRequest<InvitationValidationResponse>(() =>
      unauthorizedAPI.get(`/invitation/validate/${token}`)
    );
  }

  acceptInvitation(token: string) {
    return utils.handleApiRequest(() =>
      authorizedAPI.post(`/invitation/accept/${token}`)
    );
  }
}

export const invitationService = new InvitationService();

